import { CmsApiReactionType } from 'modules/cms/api/reactions/types/CmsApiReactionType';
import { CmsApiPageId } from 'modules/cms/api/types/CmsApiTypedId';

export type PreSignupReaction = {
  postId: CmsApiPageId;
  reactionType: CmsApiReactionType;
};

export const IDEALIST_REACTION_KEY = 'idealistPreSignupReaction';

export const IDEALIST_COMMENT_KEY = 'idealistPreSignupComment';
